var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileySad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 10.125C9.6875 10.7118 9.2118 11.1875 8.625 11.1875C8.0382 11.1875 7.5625 10.7118 7.5625 10.125C7.5625 9.5382 8.0382 9.0625 8.625 9.0625C9.2118 9.0625 9.6875 9.5382 9.6875 10.125Z",
    stroke: "#2C2E2E",
    strokeWidth: 0.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4375 10.125C16.4375 10.7118 15.9618 11.1875 15.375 11.1875C14.7882 11.1875 14.3125 10.7118 14.3125 10.125C14.3125 9.5382 14.7882 9.0625 15.375 9.0625C15.9618 9.0625 16.4375 9.5382 16.4375 10.125Z",
    fill: "black",
    stroke: "#2C2E2E",
    strokeWidth: 0.125
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11.25C9.24632 11.25 9.75 10.7463 9.75 10.125C9.75 9.50368 9.24632 9 8.625 9C8.00368 9 7.5 9.50368 7.5 10.125C7.5 10.7463 8.00368 11.25 8.625 11.25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 11.25C15.9963 11.25 16.5 10.7463 16.5 10.125C16.5 9.50368 15.9963 9 15.375 9C14.7537 9 14.25 9.50368 14.25 10.125C14.25 10.7463 14.7537 11.25 15.375 11.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8978 16.4999C15.5027 15.8157 14.9344 15.2476 14.2502 14.8526C13.5659 14.4576 12.7898 14.2496 11.9997 14.2496C11.2096 14.2496 10.4335 14.4576 9.7492 14.8526C9.06494 15.2475 8.4967 15.8157 8.10156 16.4998",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileySad);
export default __webpack_public_path__ + "static/media/smiley-sad.9a81aadeef8ef2c21515005243bd6af9.svg";
export { ForwardRef as ReactComponent };